var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElPrixMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 717.97 112.61"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "ElPrixMobile_svg__a",
  cx: -504.53,
  cy: 12.71,
  fx: -504.53,
  fy: 12.71,
  r: 382.72,
  gradientTransform: "matrix(.63 0 0 .19 738.33 10.26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#93e09a",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff6ce",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ElPrixMobile_svg__b",
  cx: -599.02,
  cy: 12.71,
  fx: -599.02,
  fy: 12.71,
  r: 382.72,
  gradientTransform: "matrix(.66 0 0 .19 840.25 10.26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a3c7ff",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff6ce",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ElPrixMobile_svg__c",
  cx: 1794.5,
  cy: 12.25,
  fx: 1794.5,
  fy: 12.25,
  r: 382.72,
  gradientTransform: "matrix(.57 0 0 .23 -754.25 9.86)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffa4de",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff6ce",
  stopOpacity: 0
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M151.01 12.56c1.85 45.34 119.85 81.91 265.14 81.91s263.28-36.58 265.13-81.91H151.01Z",
  style: {
    fill: "url(#ElPrixMobile_svg__a)",
    opacity: 0.6,
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.48 12.56c1.93 45.34 125.32 81.91 277.25 81.91s275.3-36.58 277.24-81.91H163.48Z",
  style: {
    strokeWidth: 0,
    fill: "url(#ElPrixMobile_svg__b)",
    opacity: 0.5
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.54 12.56c1.65 55.38 107.01 100.05 236.74 100.05S494.37 67.94 496.02 12.56H22.54Z",
  style: {
    fill: "url(#ElPrixMobile_svg__c)",
    opacity: 0.4,
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.34 10C110.8 26.7 221.43 4.86 332.07 3.4c22.16-1.28 44.4.1 66.56.68 29.58.76 59.14 4.38 88.37 8.49 21.94 3.06 43.97 3.59 66.01 1.58 22.11-1.72 44.26-3.05 66.43-3.81 29.56-1.04 59.12-1.13 88.68-.99.33 0 .6.27.59.6 0 .33-.27.59-.59.59-29.55.16-59.09.55-88.59 1.9-22.13.99-44.22 2.54-66.28 4.49-7.35.65-14.78 1.2-22.2 1.43-29.7 1.08-59.03-4.85-88.44-7.46-33.03-3.14-66.29-3.24-99.44-3.56-7.37-.29-14.75-.72-22.13-.49-92.31.72-184.32 16.37-276.68 8.41-14.75-1.09-29.48-2.48-44.11-4.68a.293.293 0 0 1-.25-.33c.02-.16.18-.27.34-.25Z",
  style: {
    fill: "#ff67ca",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.3 10.69c66.07.39 132.06-2.79 198.05-5.47 22.03-.65 44.1-.36 66.12.61 21.91.93 44.04 2.6 65.96 3.26 14.66-.29 29.3.46 43.96.48 21.85.19 44.19-.49 66.04-.41 29.39-.03 58.83 1.52 88.08 4.21 12.5 1.09 31.32 3.03 43.81 2.88 29.33.14 58.41-4.86 87.63-7.12C674.6 7.95 689.3 7.35 704 7.43c.33 0 .6.27.59.6 0 .33-.27.59-.59.59-14.66.08-29.31.83-43.91 2.16-29.26 2.58-58.29 7.88-87.77 8.06-12.56.28-31.31-1.46-44.06-2.43-29.24-2.39-58.49-3.64-87.83-3.31-29.23.14-58.87 1.29-88.12.66-7.36-.03-14.7-.65-22.02-1.31-21.27-1.08-44.81-2.79-65.95-3.97-58.65-3.65-117.31 1.26-175.97 2.04-29.35.62-58.71 1.01-88.08.76-.16 0-.29-.13-.29-.3 0-.16.14-.29.3-.29Z",
  style: {
    fill: "#7bd981",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.64 8.46c41.54 3.92 83.4 3.04 125.02.92 41.66-2.67 83.25-6.63 125-8C299.4.16 334.34-.81 369.09.97c20.86 1.15 41.74 1.72 62.58 3.26 27.74 1.23 55.36 6.64 83.04 7.61 27.73.24 55.47-3.74 83.21-4.93 27.84-1.22 56.25-1.59 83.78-.42-27.57 1.25-55.91.72-83.64 2.8-32.99 1.66-66.02 7.65-99.13 4.35-8.65-.9-17.35-2.16-25.92-3.27-41.37-5.29-83.14-7.46-124.83-7.03-69.57-1.41-139.01 3.68-208.4 8.11-34.77 1.61-69.65 1.82-104.39-.53-6.95-.47-13.88-1.04-20.81-1.88a.3.3 0 0 1-.26-.33.3.3 0 0 1 .33-.26Z",
  style: {
    fill: "#61a1ff",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.67 9.34c48.84 4.97 98.17 4.47 147.13 1.52 16.58-1.23 36.13-2.74 52.56-3.66 72.68-4.04 148.43-1.51 221.3-.32 36.89.95 73.66 4.05 110.48 1.01 11.91-.91 24.9-2.01 36.83-2.24 21.1-.54 42.17 1.38 63.2 2.42 14.03.93 28.59.62 42.35 1.43-13.79.8-28.35-.07-42.4-.44-28.04-1.41-56.09-3.33-84.12-.83-13.87 1.11-28.25 2.18-42.1 2.48-28.16.76-56.23-1.65-84.28-2.13-69.78-1.47-140.96-2.89-210.56 1.43-42.05 2.39-84.17 6.5-126.34 5.71-28.12-.42-56.28-1.77-84.14-5.79a.293.293 0 0 1 .08-.58Z",
  style: {
    fill: "#ffefa0",
    strokeWidth: 0
  }
})));
export default SvgElPrixMobile;